<div>
	<bb-loading *ngIf="loading"></bb-loading>
	<ng-container *ngFor="let viewer of filteredViewers; let vi = index">
		<section class="viewer" *ngIf="vi < nrToShow" [ngClass]="[ viewer.justAdded ? 'just-added' : '', viewer.pinned ? 'pinned' : '', viewer.isRemoved ? 'removed' : '']" (click)="log(viewer)">
			<div class="view-session" *ngFor="let viewSession of viewer.viewSessions; let i = index" [hidden]="!viewer.showSessions && i !== 0" [ngClass]="'playstate-' + viewSession.playState">
				<ng-container *ngIf="viewSession && viewSession.currentMediaclip">
					<header (click)="sessionClicked(viewer)">
						<span class="pin"><i [ngClass]="['fa', viewer.pinned ? 'fa-lock' : 'fa-unlock']"></i></span>
						<!-- <span class="is-mobile">{{ viewer.isMobile }}</span> -->
						<ng-container *ngIf="viewSession.phase === 'PRE' || viewSession.phase === 'POST'">
							<span class="title ad-info" *ngIf="viewSession.activeAdPosition">
								{{ viewSession.activeAdPosition.position }} ad: {{ viewSession.activeAdPosition.ad_title }}
							</span>
						</ng-container>
						<ng-container *ngIf="!(viewSession.phase === 'PRE' || viewSession.phase === 'POST') && viewSession.currentMediaclip && viewSession.currentMediaclip.title">
							<span class="title" [innerHTML]="viewSession.currentMediaclip.title"></span>
						</ng-container>
						<span class="right">
							
							<span class="device-info" *ngIf="viewer && viewer.deviceInfo && viewer.deviceInfo.deviceType_str" [innerHTML]="viewer.deviceInfo | deviceInfo : 'deviceType_str'"></span>
							<span class="device-info" *ngIf="viewer && viewer.deviceInfo && viewer.deviceInfo.browserName_str" [innerHTML]="viewer.deviceInfo | deviceInfo : 'browserName_str'"></span>
							<!-- <span class="browser" *ngIf="viewer && viewer.deviceInfo && viewer.deviceInfo" [title]="viewer.deviceInfo | json">{{ viewer.deviceInfo.browserName_str}}</span> -->
							<!-- <i class="fa fa-chrome"></i> -->
							<span class="location" *ngIf="viewer && viewer.geoInfo && viewer.geoInfo.country_code" [title]="viewer.geoInfo.country_name">
								<bb-flag [countryCode]="viewer.geoInfo.country_code.toLowerCase()"></bb-flag>
								<!-- <span [ngClass]="'flag-' + viewer.geoInfo.country_code.toLowerCase()"></span> -->
							</span>
							<span class="duration" *ngIf="viewSession.duration && (viewSession.currentMediaclip && viewSession.currentMediaclip.sourcetype !== 'live')">{{ viewSession.duration | seconds }}</span>
							<span class="duration" *ngIf="viewSession.currentMediaclip && viewSession.currentMediaclip.sourcetype === 'live'">{{ 'LIVE' | translate }} </span>
						</span>
					</header>
					<main>
						<div *ngIf="viewSession.currentMediaclip.id && viewer.publication" class="thumb">
							<div class="pause-overlay"><i class="fa fa-pause"></i></div>
							<img [src]="getThumbUrl(viewSession.currentMediaclip.id, 150, 84, viewer.publication)" alt="" />
						</div>
						<!-- [innerHTML]="viewSession.currentMediaclip | thumbnail : 50:28 | async" -->
						<!-- <div class="live-wrapper"
							*ngIf="viewSession.currentMediaclip && viewSession.currentMediaclip.sourcetype === 'live'">
							<ng-container [ngSwitch]="viewSession.playState">
								<ng-container *ngSwitchDefault>
								</ng-container>
								<ng-container *ngSwitchCase="'playing'">
									<img src="/resources/img/realtime/ticker/Play.svg" alt="" />
								</ng-container>
								<ng-container *ngSwitchCase="'paused'">
									<img src="/resources/img/realtime/ticker/Pause.svg" alt="" />
								</ng-container>
								<ng-container *ngSwitchCase="'finished'">
									<img src="/resources/img/realtime/ticker/Completed.svg" alt="" class="finished"/>
								</ng-container>
							</ng-container>
							{{ 'WATCHING_LIVE' | translate }}, {{ 'TOTAL_VIEWTIME' | translate }}: {{ viewer.totalViewTime | seconds }}
						</div> -->
						<div class="ranges-wrapper"
							[ngClass]="{'with-preroll' : viewSession.adInfo && viewSession.adInfo.preroll && viewSession.adInfo.preroll.played, 'with-postroll' : viewSession.adInfo && viewSession.adInfo.postroll && viewSession.adInfo.postroll.played}">
							<div class="ad-info" *ngIf="viewSession.adInfo">
								<div class="preroll" *ngIf="viewSession.adInfo.preroll && viewSession.adInfo.preroll.played" [title]="('PREROLL' | translate) + viewSession.adInfo.preroll && viewSession.adInfo.preroll.ad_title ? ': ' + viewSession.adInfo.preroll.ad_title : ''">
									$
								</div>
								<div class="postroll" *ngIf="viewSession.adInfo.postroll && viewSession.adInfo.postroll.played" [title]="('POSTROLL' | translate) + viewSession.adInfo.postroll && viewSession.adInfo.postroll.ad_title ? ': ' + viewSession.adInfo.postroll.ad_title : ''">
									$
								</div>
							</div>
							<ng-container *ngIf="viewSession && viewSession.currentMediaclip && viewSession.currentMediaclip.sourcetype === 'live'">
								<div class="ranges" [ngClass]="'playstate-' + viewSession.playState">
									<div class="range" style="left: 0;" [ngStyle]="{width: ( ((viewer.totalViewTime / _maxLiveViewtime ) * 100) < 10 ? 10 : ((viewer.totalViewTime / _maxLiveViewtime ) * 100) > 90 ? 90 : ((viewer.totalViewTime / _maxLiveViewtime ) * 90)) + '%'}">
										<div class="live-viewtime">
											{{ viewer.totalViewTime | seconds }}
										</div>
										<div class="event-icon">
											<ng-container [ngSwitch]="viewSession.playState">
												<ng-container *ngSwitchDefault>
												</ng-container>
												<ng-container *ngSwitchCase="'playing'">
													<img src="/resources/img/realtime/ticker/Play.svg" alt="" />
												</ng-container>
												<ng-container *ngSwitchCase="'paused'">
													<img src="/resources/img/realtime/ticker/Pause.svg" alt="" />
												</ng-container>
												<ng-container *ngSwitchCase="'finished'">
													<img src="/resources/img/realtime/ticker/Completed.svg" alt="" class="finished"/>
												</ng-container>
											</ng-container>
										</div>
									</div>
									<div class="live-text" [ngStyle]="{left: ( ((viewer.totalViewTime / _maxLiveViewtime ) * 100) < 10 ? 10 : ((viewer.totalViewTime / _maxLiveViewtime ) * 100) > 90 ? 90 : ((viewer.totalViewTime / _maxLiveViewtime ) * 90)) + '%'}">
										{{ 'LIVE' | translate }}
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="viewSession.currentMediaclip && viewSession.currentMediaclip.sourcetype !== 'live'">
								<div class="ranges" *ngIf="viewSession && viewSession.ranges && viewSession.duration" [ngClass]="'playstate-' + viewSession.playState">
							
									<div class="range" 
										*ngFor="let range of viewSession.ranges"
										[ngStyle]="{ left: (range.from / viewSession.duration)*100 + '%', width: viewSession.currentMediaclip && viewSession.currentMediaclip.sourcetype === 'live' ? 50 : ((((range.isActive && viewSession.playState === 'playing' ? (range.to) : range.to) - range.from) / viewSession.duration)*100) + '%' }"
										[ngClass]="{'current-range': range.isActive}"
										[attr.title]="range.from + ' - ' + range.to">
										<div *ngIf="range && range.events && range.events.length && range.events[range.events.length - 1]" class="event-icon">
											<span [ngSwitch]="range.events[range.events.length - 1].ev" [ngClass]="range.events[range.events.length - 1].ev">
												<ng-container [ngSwitch]="viewSession.playState" *ngIf="range.isActive">
													<ng-container *ngSwitchDefault>
													</ng-container>
													<ng-container *ngSwitchCase="'playing'">
														<img src="/resources/img/realtime/ticker/Play.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'paused'">
														<img src="/resources/img/realtime/ticker/Pause.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'finished'">
														<img src="/resources/img/realtime/ticker/Completed.svg" alt="" class="finished"/>
													</ng-container>
												</ng-container>

												<ng-container *ngIf="!range.isActive">
													<ng-container *ngSwitchDefault>
														<img src="/resources/img/realtime/ticker/Play.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'se'">
														<img *ngIf="range.events[range.events.length - 1].to > range.to" src="/resources/img/realtime/ticker/SkipForward.svg" alt="" />
														<img *ngIf="!(range.events[range.events.length - 1].to > range.to)" src="/resources/img/realtime/ticker/SkipBack.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'st'">
														<img src="/resources/img/realtime/ticker/Play.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'rs'">
														<img src="/resources/img/realtime/ticker/Play.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'pa'">
														<img src="/resources/img/realtime/ticker/Pause.svg" alt="" />
													</ng-container>
													<ng-container *ngSwitchCase="'fn'">
														<img src="/resources/img/realtime/ticker/Completed.svg" alt="" class="finished" />
													</ng-container>
												</ng-container>
											</span>
										</div>
									</div>
									<div class="interaction range" *ngFor="let ev of viewSession.interactions" [ngStyle]="{ left: (ev.to / viewSession.duration)*100 + '%', width: 0 }">
										<div class="event-icon">
											<span>
												<img src="/resources/img/realtime/ticker/Interaction.svg" alt="" />
											</span>
										</div>
									</div>
								</div>
							</ng-container>
						</div>

						<div class="info">
							<div class="info-left">
								{{ 'ACTIVE_SINCE' | translate }}: <strong *ngIf="viewer.firstSighting" [innerHTML]="viewer.firstSighting | date:'HH:mm'"></strong> | 
								{{ 'LAST_ACTIVITY' | translate }}: <strong *ngIf="viewer.lastSighting" [innerHTML]="viewer.lastSighting | date:'HH:mm'"></strong>
								<br />
								<a target="_blank" [href]="viewSession.referrer" [title]="viewSession.referrer">{{ viewSession.domain }}</a>
							</div>
							<div class="info-right">
								<span class="browser" *ngIf="viewer && viewer.deviceInfo && viewer.deviceInfo && viewer.deviceInfo.browserVersion_str">
									{{ viewer.deviceInfo.browserVersion_str.split('.')[0] }}
								</span><br />
								<span class="browser" *ngIf="viewer && viewer.deviceInfo && viewer.deviceInfo && viewer.deviceInfo.osVersion_str">
									{{ viewer.deviceInfo.osVersion_str }}
								</span>
							</div>
							<div class="info-center">
								&nbsp;<br />
								<span [title]="'TOTAL_VIEWTIME' | translate">
									{{ viewer.totalViewTime | seconds }}
								</span>
								<span>
									/ {{ viewer.clipsWatched }} {{ ( viewer.clipsWatched === 1 ? 'CLIP' : 'CLIPS') | translate }}
								</span>
								<span>
									/ {{ viewer.adsWatched ? viewer.adsWatched : 0 }} {{ (viewer.adsWatched === 1 ? 'AD' : 'ADS') | translate }}
								</span>
							</div>
						</div>
					</main>
					<footer *ngIf="isRoot">
						<span *ngIf="viewer.viewSessions" (click)="viewer.showSessions = viewer.viewSessions.length > 1 && !viewer.showSessions" [ngStyle]="{cursor: viewer.viewSessions && viewer.viewSessions.length < 2 ? 'auto' : 'pointer'}">Clips: {{ viewer.clipsWatched }}</span> |
						Active since: <span *ngIf="viewer.firstSighting" [innerHTML]="viewer.firstSighting | date:'HH:mm:ss'"></span> | 
						Last activity: <span *ngIf="viewer.lastSighting" [innerHTML]="viewer.lastSighting | date:'HH:mm:ss'"></span> | 
						<!-- started: <span [innerHTML]="viewSession.startTime | bbDate:'relative'"></span> -->
						<span *ngIf="viewer.totalViewTime">Total viewtime: {{ viewer.totalViewTime | seconds }}</span> | 
						<span>UID: {{ viewSession.uid }}</span> | 
						<span>SID: {{ viewSession.sid }}</span>
					</footer>
				</ng-container>
			</div>
		</section>
	</ng-container>
</div>
